<template>
  <div class="content">
      <div class="row">
          <div class="col-md-12">
              <a-card>
                <form @submit.prevent="addData($event)">
                        <div class="row">
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>نام</label>
                                    <input type="text" name="name" v-model="info.name" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>تعداد  </label>
                                    <input type="number" name="count" v-model="info.count" class="form-control" />
                                </div>
                            </div>

                            <hr class="mt-5">

                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                              
                                <div class="col-md-1 ">
                                    <router-link to="/categories/list" class="btn btn-fill btn-outline-danger w-100">
                                        بازگشت</router-link>
                                </div>

                            </div>

                        </div>
                    </form>
              </a-card>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
      data() {
          return {
              info: {
              },
              parents:[]
            
          };
      },
      mounted() {
          let _this = this;
          axios
                .get("/units/single/" + this.$route.params.id)
                .then(function(response) {
                    _this.info = response.data;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
      },
      methods: {
         
          addData(event) {
              let _this = this;
              let data = new FormData(event.target);
              _this.$root.loading = true;
              axios
                  .post("/units/edit/"+ this.$route.params.id, data)
                  .then(function(response) {
                      _this.$root.loading = false;
                      _this.$toast.success(" واحد مورد نظر با موفقیت ذخیره شد");
                      _this.$router.push("/units/list");
                  })
                  .catch(function(err) {
                      _this.$root.loading = false;
                      _this.$root.handleAxiosError(err);
                  });
          },
      },
  };
</script>
